/* eslint-disable react/forbid-prop-types */
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { compose } from 'redux';
import useIsMobile from 'shared/hooks/useIsMobile';
import normalizeCss from 'normalize.css';
import BrowserSupportCheck from 'shared/components/BrowserSupportCheck';
import FooterV2 from 'shared/components/Footer/FooterV2';
import SessionErrorBanner from 'marketplace/components/banner/SessionErrorBanner';
import s from './Layout.css';
import Header from '../Header';

function Layout({ children }) {
  const isMobile = useIsMobile();

  // first render is on server, where window doesn't exist, so make sure that doesn't
  // crash things
  const isConversation =
    typeof window !== 'undefined' &&
    typeof window.location !== 'undefined' &&
    window.location.pathname.includes('/conversation');

  const hideHeaderAndFooter = isMobile && isConversation;

  return (
    <div>
      {!hideHeaderAndFooter && <Header />}
      <SessionErrorBanner />
      {children}
      {!hideHeaderAndFooter && (
        <>
          <FooterV2 />
        </>
      )}
      <BrowserSupportCheck />
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default compose(withStyles(normalizeCss, s))(Layout);
